<template>
  <div
    @click.stop="$emit('setVerified', activity)"
    :class="[$style.card, { [$style.chosen]: activity.verified }]"
  >
    <img
      v-if="activity.verified"
      src="/icons/analytics/chosen.svg"
      alt=""
      :class="$style.icon"
    />
    <img
      v-else
      src="/icons/analytics/no-chosen.svg"
      alt=""
      :class="$style.icon"
    />
    <img
      @click.stop="$emit('openModal', activity)"
      src="/icons/analytics/dots.svg"
      alt=""
      :class="$style.dots"
    />
    <div>
      {{ activity?.planned_start_time || "--:--:--" }} /
      {{ activity?.start_date?.substr(11, 8) || "--:--:--" }}
    </div>
    <div>
      {{ activity?.planned_end_time || "--:--:--" }} /
      {{ activity?.end_date?.substr(11, 8) || "--:--:--" }}
    </div>
    <div>{{ activity.activity.name }}</div>
    <div>
      {{ activity?.planned_delta || "--:--:--" }} /
      {{ activity.delta || "--:--:--" }}
    </div>
    <div :class="$style.images">
      <div
        v-for="comment in activity.comments"
        :key="comment.id"
        :class="$style.image"
      >
        <template v-for="file in comment.files" :key="file.id">
          <img
            v-if="isImage(file.file)"
            @click.stop="$emit('openImage', comment, file.file)"
            :src="file.file"
            alt=""
          />
          <a
            v-else
            @click.stop="downloadFile(file.file)"
            :class="$style.downloadLink"
          >
            <img src="/icons/common/add-file-black.svg" alt="" />
          </a>
        </template>
      </div>
    </div>
    <div>
      {{ activity?.comments?.map((i) => i.text)?.join(", ") || "-" }}
    </div>
    <div :class="$style.comment" :title="activity?.admin_comment">
      {{ activity?.admin_comment || "-" }}
    </div>
  </div>
</template>

<script>
import { isImage } from "@/utils/file";
import ApiConnector from "@/repository/connector";
import Axios from "axios";

export default {
  name: "ActivityCard",
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  emits: ["setVerified", "openModal", "openImage"],
  methods: {
    isImage,
    async downloadFile(fileUrl) {
      try {
        let response;
        let contentType = "";
        let contentDisposition = "";

        // Определяем, является ли URL полным или относительным
        if (fileUrl.startsWith("http")) {
          // Для полных URL создаем axios запрос без baseURL
          // const userData = localStorage.getItem("userData");
          // const token = userData ? JSON.parse(userData).access : null;

          //const headers = {};
          // if (token) {
          //   headers["authorization"] = `Bearer ${token}`;
          // }

          // Используем axios напрямую для полных URL
          response = await Axios.get(fileUrl, {
            responseType: "blob",
            //headers: headers,
          });

          contentType = response.headers["content-type"] || "";
          contentDisposition = response.headers["content-disposition"] || "";
        } else {
          // Для относительных URL используем ApiConnector
          const requestUrl = fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`;

          response = await ApiConnector.connector.get(requestUrl, {
            responseType: "blob",
          });

          contentType = response.headers["content-type"] || "";
          contentDisposition = response.headers["content-disposition"] || "";
        }

        // Проверяем Content-Type заголовок, чтобы определить, не является ли ответ ошибкой в формате JSON
        if (contentType.includes("application/json")) {
          const text = await response.data.text();
          const errorData = JSON.parse(text);
          console.error("Ошибка при скачивании файла:", errorData);
          return;
        }

        const blob = new Blob([response.data]);
        this.downloadBlob(blob, fileUrl, contentDisposition);
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
        // Если ошибка в формате blob, пытаемся прочитать как JSON
        if (error.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const errorData = JSON.parse(text);
            console.error("Ошибка API:", errorData);
          } catch {
            console.error("Ошибка при обработке ответа:", error);
          }
        }
      }
    },
    downloadBlob(blob, fileUrl, contentDisposition) {
      // Создаем временную ссылку для скачивания
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Получаем имя файла из заголовка Content-Disposition или из URL
      let filename = "file";

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      } else {
        // Пытаемся извлечь имя файла из URL
        const urlParts = fileUrl.split("/");
        const urlFilename = urlParts[urlParts.length - 1];
        if (urlFilename && urlFilename.includes(".")) {
          filename = urlFilename.split("?")[0]; // Убираем query параметры
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>

<style lang="scss" module>
.card {
  background-color: $bg-white;
  flex: 0 0 17.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
  position: relative;
  border: 0.125rem solid $bg-white;
  &.chosen {
    border: 0.125rem solid $blue;
  }
  .icon {
    position: absolute;
    top: 1rem;
    left: 1rem;
    cursor: pointer;
  }
  .dots {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
  }
  div {
    padding: 0.75rem 0;
    border-bottom: 1px solid $gray-34;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 15.5rem;
    &:last-child {
      border: none;
    }
  }
  .comment {
    padding: 0.75rem 0;
    border-bottom: 1px solid $gray-34;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 15.5rem;
    display: block;
  }
  .images {
    padding: 0;
    display: flex;
    gap: 0.5rem;
    width: auto;
    height: 2.75rem;
    .image {
      display: flex;
      gap: 0.5rem;
      width: auto;
      border: none;
      img {
        border: 1px solid rgba(122, 130, 143, 1);
        border-radius: 0.25rem;
        width: 1.25rem;
        height: 1.25rem;
        object-fit: cover;
      }
    }
  }
  .downloadLink {
    cursor: pointer;
    display: inline-block;
  }
}
</style>

